<template>
    <div>
        <sub-controller
                v-if="clone.rotate"
                :image="'rotate.png'"
                @click.prevent.stop="rotate()"
        >
        </sub-controller>
        <!-- <sub-controller
                v-if="clone.ide"
                :image="'terminal.png'"
                @click.prevent.stop="ide()"
        >
        </sub-controller> -->
        <!-- <sub-controller
                v-if="clone.clear"
                :image="'brush.png'"
                @click.prevent.stop="clear()"
        >
        </sub-controller> -->
        <!-- <sub-controller
                v-if="clone.code"
                :image="'code.png'"
                @click.prevent.stop="code()"
        >
        </sub-controller> -->
        <sub-controller
                :image="'copy.png'"
                @click.prevent.stop="copyPaste()"
        ></sub-controller>
    </div>

</template>

<script>
    var Minio = require('minio');
    import TenantAware from "../../labs/TenantAware";

    export default {
        name: 'storming-sub-controller',
        props: {
            type: String,
            className: String,
            calleeDefinitionId: String,
            elementId: String,
            value: Object,
            readOnly: {
                type: Boolean,
                default: function () {
                    return false;
                }
            }
        },
        mixins: [TenantAware],
        computed: {},
        data: function () {
            return {
                clone: {
                    rotate: false,
                    gateway: false,
                    ide: false,
                    clear: false,
                    code: false
                },
                options: [
                    {
                        name: 'IDE',
                    }
                ],
                canvansbase: null
            }
        },
        watch: {
            'readOnly': function (newVal) {
                console.log(newVal)
            }
        },
        mounted: function () {
            var me = this
            if (!me.readOnly)
                this.clone.rotate = true;

            if (this.type == "org.uengine.modeling.model.BoundedContext") {
                this.clone.ide = true;
                this.clone.clear = true;
                this.clone.code = true;
            } else if (this.type.includes("org.uengine.modeling.model")) {
                this.clone.code = true;
            }
            me.canvasbase = me.getComponent('event-storming-model-canvas')

        },
        /**
         * clone : 컨트롤러에 의해 신규 bpmn 이 생성되었을 경우
         * showComponentChange : 컨트롤러중 렌치 모양을 클릭하여 도형 변경 창을 여는 경우
         */
        methods: {
            end() {

            },
            copyPaste() {
                var me = this;
                me.$EventBus.$emit('copyPaste', me.value.elementView.id);
            },
            handleClick(event) {
                event.pageY = event.pageY - 62;
                this.$refs.vueSimpleContextMenu.showMenu(event)
            },
            optionClicked(event) {
                var me = this
                console.log(me.className);
                console.log(me)
                if (event.option.name == 'Get Pods') {
                    me.getPods();
                } else if (event.option.name == 'IDE') {
                    me.ide();
                } else if (event.option.name == 'Serivce') {
                    me.service();
                }
            },
            getPods() {
                $('iframe').get(0).contentWindow.wt.term.term.send("kubectl get po \r")
            },
            ide() {
                var me = this
                var userName = localStorage.getItem("author").split('@')[0].toLowerCase();
                var userGroup = localStorage.getItem("author").split('@')[1].split('.')[0].toLowerCase();
                var modelingDesigner = me.getComponent('event-storming-model-canvas')
                console.log(`${userName}-${userGroup}-${modelingDesigner.projectName}-${me.$parent.$parent.value.name}`)
                me.$http.get(`https://api.${me.getTenantId()}/api/v1/namespaces/default/services/ide-for-${userName}-${userGroup}-${modelingDesigner.projectName.toLowerCase()}-${me.$parent.$parent.value.name.toLowerCase()}`).then(function (result) {
                    window.open(`#/IdeLoadingPage?param=ide-for-${userName}-${userGroup}-${modelingDesigner.projectName.toLowerCase()}-${me.$parent.$parent.value.name.toLowerCase()}`, '_blank')
                }).catch(function (e) {
                    if (e.toString().includes(500)) {
                        // 없을 경우 접속 (500 에러로 판단)
                        me.$EventBus.$emit('deploy', me.$parent.$parent.value.elementView.id);
                    }
                })
            },
            service() {
                var me = this
                // console.log(me.$parent.$parent.value.elementView.id)
                me.$EventBus.$once('returnDeployData', function (data) {
                    var serviceFileKey, serviceFileCode;
                    data.fullPathList.forEach(function (itemKey) {
                        if (itemKey.fullPath.includes('kubernetes/service')) {
                            serviceFileKey = itemKey.key
                        }
                    })
                    data.getCodeList.forEach(function (itemCode) {
                        if (itemCode.key == serviceFileKey) {
                            serviceFileCode = itemCode.code
                        }
                    })
                    console.log(serviceFileCode);
                })
                me.$EventBus.$emit('service', me.$parent.$parent.value.elementView.id);
            },
            clear() {
                var me = this
                var objectsList = []
                var minioClient = new Minio.Client({
                    endPoint: 'minio-std.msaez.io',
                    port: 443,
                    useSSL: true,
                    accessKey: 'minio',
                    secretKey: 'minio123'
                });
                var userName = localStorage.getItem("author").split('@')[0].toLowerCase();
                var userGroup = localStorage.getItem("author").split('@')[1].split('.')[0].toLowerCase();
                var modelingDesigner = me.getComponent('event-storming-model-canvas')
                console.log(`${userGroup}-${userName}-${modelingDesigner.projectName}-${me.$parent.$parent.value.name}`)
                var objectsStream = minioClient.listObjects('eventstorming', `${userGroup}/${userName}/${modelingDesigner.projectName.toLowerCase()}/${me.$parent.$parent.value.name}`, true);
                objectsStream.on('data', function (obj) {
                    console.log(obj)
                    objectsList.push(obj.name);
                })

                objectsStream.on('error', function (e) {
                    console.log(e);
                })

                objectsStream.on('end', function () {
                    minioClient.removeObjects('eventstorming', objectsList, function (e) {
                        if (e) {
                            return console.log('Unable to remove Objects ', e)
                        }
                        modelingDesigner.deleteBounded = me.$parent.$parent.value.name;
                        modelingDesigner.deleteSnackbar = true;
                    })
                })
            },
            rotate() {
                var me = this
                var positionX = this.value.elementView.x / 1000
                var positionY = this.value.elementView.y / 1000
                $(`#${this.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);

                if (this.value.rotateStatus) {
                    $(`#${this.value.elementView.id}`).css('transform', `rotate(0deg)`);
                    this.value.rotateStatus = false
                    this.$emit('update:rotateStatus', this.value)
                } else {
                    $(`#${this.value.elementView.id}`).css('transform', `rotate(-30deg)`);
                    this.value.rotateStatus = true
                    this.$emit('update:rotateStatus', this.value)
                }
                me.canvasbase.changedByMe = true
            },
            async code() {
                var me = this
                var modelCanvas = me.getComponent('event-storming-model-canvas');
                // if()
                var fullPathList = modelCanvas.fullPathList;
                var getCodeList = modelCanvas.getCodeList;
                if (getCodeList.length < 1) {
                    modelCanvas.getListSetting();
                    function sleep(ms) {
                        return new Promise(resolve => setTimeout(resolve, ms))
                    }

                    while (!modelCanvas.mergeStatus) {
                        await sleep(3000);
                    }
                    if(modelCanvas.mergeStatus) {
                        return me.code();
                    }

                }
                var returnArray = [];

                getCodeList.forEach(function (code, idx) {
                    if (code.element == me.value.elementView.id) {
                        var data = {
                            name: code.fileName,
                            key: code.key,
                            file: code.file,
                            code: code.code,
                            path: fullPathList[idx].fullPath,
                            changed: 0
                        }
                        returnArray.push(data)
                    }
                });

                modelCanvas.codeViewing = true;
                modelCanvas.treeList = returnArray;
                modelCanvas.openCodeViewer();
            },
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">

</style>